import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export default function Copyright() {
  return (
    <Typography
      variant="subtitle1"
      color="customText.main"
      align="center"
    >
      {'Copyright © '}
      <Link color="inherit">
        Peter Lee.
      </Link>{' '}
      All Rights Reserved
    </Typography>
  );
}